import { SelectedCoworkingType } from 'shared/enums/SelectedCoworkingType';
import { useReduxSelector } from 'shared/hooks/useReduxSelector';
import { selectedCoworkingTypeSelector } from 'shared/store/coworking/selectors/smart/selectedCoworkingTypeSelector';

export function useSelectedCoworkingTypeSelector(): SelectedCoworkingType {
  return useReduxSelector<SelectedCoworkingType>(selectedCoworkingTypeSelector);
}
